import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">555电影</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              555电影为您汇集电视剧全集免费在线观看，最新热播剧集、国产剧、韩剧等高清资源，无需缓冲，追剧首选平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">影视分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>contact@555movie.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400"></i>
                <span>在线客服 7×24小时</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-[1200px] mx-auto mt-10 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-400">
            <p>&copy; {new Date().getFullYear()} 555电影 版权所有 | 本站所有资源均来自互联网，仅供学习交流使用</p>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-accent-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}